import { useState } from 'react';

export type UseModalVisibilityHookReturn = {
  isVisible: boolean;
  showModal: () => void;
  hideModal: () => void;
};

export const useModalVisibility = (
  initiallyVisible = false
): UseModalVisibilityHookReturn => {
  const [isVisible, setIsVisible] = useState(initiallyVisible);

  const showModal = () => setIsVisible(true);
  const hideModal = () => setIsVisible(false);

  return { isVisible, showModal, hideModal };
};
